/* eslint-disable no-console */
/* eslint-disable no-param-reassign */
import React from "react";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import APIHelper from "@giscon/utils.api-helper-esri";

const filter = createFilterOptions();
export default class AutocompleteWOMap extends React.Component {
  constructor(props) {
    if (!props.map) {
      throw new Error("map has to be a prop to use AutocompleteWOMap");
    }
    super(props);
    this.state = {
      additionalOption: null,
    };
  }

  render() {
    const { additionalOption } = this.state;
    const xprops = {};
    const ignore = {
      allowCreate: true,
      createOption: true,
      isInOptions: true,
      loading: true,
    };
    const keys = Object.keys(this.props);
    for (let i = 0; i < keys.length; i++) {
      if (!ignore[keys[i]]) xprops[keys[i]] = this.props[keys[i]];
    }

    const onFocus = () => {
      APIHelper.disableKeyboardNavigation(xprops.map, xprops.view);
    };
    const onBlur = () => {
      APIHelper.enableKeyboardNavigation(xprops.map, xprops.view);
    };
    if (xprops.onFocus) {
      const temp = xprops.onFocus;
      xprops.onFocus = function () {
        try {
          temp();
        } catch (e) {
          console.error(e);
        }
        onFocus();
      };
    } else {
      xprops.onFocus = onFocus;
    }
    if (xprops.onBlur) {
      const temp = xprops.onBlur;
      xprops.onBlur = function () {
        try {
          temp();
        } catch (e) {
          console.error(e);
        }
        onBlur();
      };
    } else {
      xprops.onBlur = onBlur;
    }

    if (this.props.allowCreate && this.props.createOption) {
      // empfehlung von Material-Ui
      xprops.selectOnFocus = true;
      xprops.clearOnBlur = true;
      xprops.handleHomeEndKeys = true;
      if (this.props.options && additionalOption) {
        xprops.options = this.props.options.concat([
          this.props.createOption(additionalOption),
        ]);
      }
      xprops.filterOptions = (options, params) => {
        const filtered = filter(options, params);

        // Suggest the creation of a new value
        if (params.inputValue !== "") {
          if (
            !this.props.isInOptions ||
            !this.props.isInOptions(this.props.options, params.inputValue)
          ) {
            if (additionalOption !== params.inputValue) {
              this.setState({ additionalOption: params.inputValue });
            }
            // const option = this.props.createOption(params.inputValue);
            // filtered.push(option); // this line is edited by GISCON to allow the programmer to fit the filtered item to the other options
          } else if (additionalOption) {
            this.setState({ additionalOption: null });
          }
        } else if (additionalOption) {
          this.setState({ additionalOption: null });
        }

        return filtered;
      };
    } else if (additionalOption) {
      this.setState({ additionalOption: null });
    }

    xprops.closeText = "";
    xprops.clearText = "";
    xprops.openText = "";
    xprops.loadingText = "wird geladen ...";
    xprops.noOptionsText = "keine Auswahl";
    return <Autocomplete {...xprops} />;
  }
}
